import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {OutlineCommentsEnum} from '@core/enums/outline-comments.enum';
import {TranslateService} from '@ngx-translate/core';
import {OutlineUnitBasicModel} from '@core/modules/rest/consent/response/outline-unit-basic.model';
import {CommentBasicModel} from '@core/modules/rest/consent/response/comment-basic.model';
import {EditCommentRequestModel} from '@core/modules/rest/consent/request/edit-comment-request.model';
import {TextSizeEnum} from '../../enums/text-size.enum';
import {SliderResponseModel} from '@shared/components/slider/model/slider-response.model';
import {Observable} from 'rxjs';
import {OutlineChapterUnitBasicModel} from '@core/modules/rest/consent/response/outline-chapter-unit-basic.model';

@Component({
    selector: 'app-display-consent-menu',
    templateUrl: './display-consent-menu.component.html',
    styleUrls: ['./display-consent-menu.component.scss']
})
export class DisplayConsentMenuComponent implements OnChanges {
    @Input() sideMenuOpen: boolean;
    @Input() treeData: OutlineChapterUnitBasicModel[] | undefined;
    @Input() currentUnitOrderId: number | undefined;
    @Input() openMenu: OutlineCommentsEnum | undefined;
    @Input() reviewerMode = false;
    @Input() comments: CommentBasicModel[] | undefined;
    @Input() consentId: string | undefined;
    @Input() textSize: TextSizeEnum | undefined;
    @Input() enableCommenting: boolean | undefined;
    @Input() hideCloseIcon: boolean;
    @Output() closeEvent = new EventEmitter<void>();
    @Output() showElementEvent = new EventEmitter<OutlineUnitBasicModel>();
    @Output() displayUnderstoodUnitAgainEvent = new EventEmitter<number>();
    @Output() addCommentEvent = new EventEmitter<string>();
    @Output() editCommentEvent = new EventEmitter<EditCommentRequestModel>();
    @Output() deleteCommentEvent = new EventEmitter<string>();
    @Output() slideChangeEvent: EventEmitter<TextSizeEnum> = new EventEmitter();
    @Output() pauseAudioEvent = new EventEmitter();

    title$: Observable<string>;
    outlineEnum = OutlineCommentsEnum.OUTLINE;
    commentsEnum = OutlineCommentsEnum.COMMENTS;
    settingsEnum = OutlineCommentsEnum.SETTINGS;


    constructor(private translate: TranslateService) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.openMenu && this.openMenu) {
            if (this.openMenu === OutlineCommentsEnum.OUTLINE) {
                this.title$ = this.translate.stream('GENERAL.OUTLINE');
            } else if (this.openMenu === OutlineCommentsEnum.COMMENTS) {
                this.title$ = this.translate.stream('GENERAL.QUESTIONS');
            } else {
                this.title$ = this.translate.stream('GENERAL.QUICK_SETTINGS');
            }
        }
    }

    sliderChange(event: SliderResponseModel): void {
        const selectedValue = TextSizeEnum[event.selected as keyof typeof TextSizeEnum];
        this.slideChangeEvent.emit(selectedValue);
    }
}
